import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import {
  EnrollmentWindowApiResponse,
  EnrollmentWindowModel,
  EnrollmentWindowTargetOptions,
  RegisterInterestApiResponse,
  RegisterInterestModel
} from './enrollment-window-service-types'
import { formatEnrollmentWindow, formatRegisterInterest } from './enrollment-window-service-utils'

type ResourceId = number | string

const getEnrollmentWindowUrl = (id: ResourceId, byProduct?: boolean) =>
  byProduct
    ? makeApiUrl(`/catalog/v2/products/${id}/enrollment`)
    : makeApiUrl(`/v2/user/courses/${id}/enrollment`)

const getInterestUrl = (id: ResourceId, byProduct?: boolean) =>
  byProduct
    ? makeApiUrl(`/catalog/v2/products/${id}/interest`)
    : makeApiUrl(`/v2/user/courses/${id}/interest`)

export const createEnrollmentWindowService = (client = httpServiceClient) => ({
  async fetchEnrollmentWindow(
    id: ResourceId,
    { byProduct }: EnrollmentWindowTargetOptions = {}
  ): Promise<EnrollmentWindowModel> {
    const response = await client<EnrollmentWindowApiResponse>({
      method: 'get',
      url: getEnrollmentWindowUrl(id, byProduct)
    })

    return formatEnrollmentWindow(response.body.data as EnrollmentWindowApiResponse)
  },

  async registerInterest(
    id: ResourceId,
    { byProduct }: EnrollmentWindowTargetOptions = {}
  ): Promise<RegisterInterestModel> {
    const response = await client<RegisterInterestApiResponse>({
      method: 'post',
      url: getInterestUrl(id, byProduct)
    })

    return formatRegisterInterest(response.body.data as RegisterInterestApiResponse)
  },

  async cancelInterest(
    id: ResourceId,
    { byProduct }: EnrollmentWindowTargetOptions = {}
  ): Promise<void> {
    await client<void>({
      method: 'delete',
      url: getInterestUrl(id, byProduct)
    })
  }
})

export const enrollmentWindowService = createEnrollmentWindowService()
